// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "mf-site-wide." + {"494":"323cbd4070d5b28c","715":"e968c563a3dac96e"}[chunkId] + ".js";
};